var map = {
	"./noble01/发红包@2x.png": "e9e2",
	"./noble02/发红包@2x.png": "cd30",
	"./noble03/发红包@2x.png": "7fa6",
	"./noble04/发红包@2x.png": "1340",
	"./noble05/发红包@2x.png": "8d11"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5cff";